import Nullstack from 'nullstack';
export default function IconTransform({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-transform",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 13v.875c0 3.383 2.686 6.125 6 6.125"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "6",
    r: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "18",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M16 9l2 2l2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M18 10v-.875c0 -3.383 -2.686 -6.125 -6 -6.125"
  }), "   ", Nullstack.element("path", {
    d: "M3 15l2 -2l2 2"
  }), " ");
}